import { GraphQLClient } from "graphql-request";
import {endpoint} from "../config";

export type ErrorsResponse = { errors: Array<{ message: string }> };


    

const client = new GraphQLClient(endpoint);

export interface GraphQLResult<T> {
  data?: T;
  error?: string;
}
export async function queryGraphQL<T>(
  query: string,
  variables: Object,
  resultKey: string
): Promise<GraphQLResult<T>> {
  try {
    const data:any = await client.request(query, variables as any);
    return { data: data[resultKey] };
  } catch (err: any) {
    if (err.response) {
      const response = err.response as unknown as ErrorsResponse;
      let message = "";
      for (const error of response.errors) {
        message += error.message + "\n";
      }
      return { error: message };
    }
    if (err.message) {
      return { error: err.messsage };
    }
    return { error: String(err) };
  }
}
